import constants from '@/constants.js';
import _ from 'lodash';
class SnapshotChartHelperService {
    AVG_METRICS_KEY = 'averageMetricsForEntireRange';

    buildAvailableDisplayPeriods (metrics, averageMetricsForEntireRange, period, daySmoothing) {
        let mappingFunc = m => ({ key: m.periodName, value: m.periodName });

        if (period.key === constants.PERIOD.DAY && daySmoothing && daySmoothing > 1) {
            mappingFunc = m => ({ key: m.periodName, value: `${m.periodStartDate} to ${m.periodEndDate}` });
        } else if (period.key === constants.PERIOD.WEEK) {
            mappingFunc = m => ({ key: m.periodName, value: `Week from ${m.periodStartDate} to ${m.periodEndDate}` });
        }
        let sortedMetrics = _.sortBy(metrics, 'day').reverse(); // Sort by date in descending order
        let mappedPeriods = _.map(sortedMetrics, mappingFunc); // Map the object to the defined shape in mappingFunc
        let availableDisplayPeriods = _.uniqBy(mappedPeriods, p => p.key); // Get the distinct periods.

        if (averageMetricsForEntireRange && averageMetricsForEntireRange.length > 0) {
            let firstMetric = averageMetricsForEntireRange[0]; // select the first metric as all the metric will have a start and end period date.
            let averageForEntireRangeItem = { key: this.AVG_METRICS_KEY, value: ` Average from ${firstMetric.periodStartDate} to ${firstMetric.periodEndDate}` };
            availableDisplayPeriods.unshift(averageForEntireRangeItem);
        }

        return availableDisplayPeriods;
    }
};

export const snapshotChartHelperService = new SnapshotChartHelperService();
